<div *ngIf="viewModel$ | async as vm">
    <h2 class="error-title">Class Errors</h2>
    <app-error-table [pagedData]="vm.pagedData" *ngIf="vm.pagedData"
                     [columns]="tableColumns"
                     (export)="onExport($event)"
                     (pageChanged)="onPageChanged($event)"
                     (sortChanged)="onSortChanged($event)" />
</div>